<div class="control-examen-container">
  <!-- Fixed header - only when exam is active -->
  <header class="fixed-header" *ngIf="(isExamenActivo$ | async)">
    <div class="title-group">
      <h1>Control de Examen</h1>
      <div class="exam-status active">
        <i class="fas fa-circle"></i>
        <span>Examen Activo</span>
      </div>
    </div>
    
    <div class="header-actions">

      <!-- Session selector -->
      <div class="session-selector" *ngIf="(isExamenActivo$ | async)">
        <label>
          <i class="fas fa-clock"></i> Examen:
        </label>
        <select [(ngModel)]="currentSessionId" (change)="onChangeSession()">
          <option *ngFor="let session of sesiones$ | async" [value]="session.id">
            {{ session.nombre }}
          </option>
        </select>
        <button class="icon-btn" (click)="onAddNewSession()" title="Nuevo examen">
          <i class="fas fa-plus"></i>
        </button>
      </div>

      <!-- Stop exam button -->
      <button (click)="finalizarExamen()" class="stop-exam-btn">
        <i class="fas fa-stop"></i> 
        <span class="btn-text">Finalizar</span>
      </button>

      <!-- PRICES button -->
      <button (click)="showPreciosModal = true" 
              class="prices-btn"
              title="Configurar precios">
        <i class="fas fa-dollar-sign"></i>
      </button>
      
      <!-- ACTUALIZAR BUTTON - Most important! -->
      <button (click)="actualizarTodos()" 
              class="refresh-btn"
              title="Actualizar estado de todos los estudiantes">
        <i class="fas fa-sync-alt"></i> 
        <span class="btn-text">Actualizar</span>
      </button>
      
      <!-- Import/Export buttons - responsive -->
      <div class="import-export-group">
        <!-- Desktop version - separate buttons -->
        <div class="desktop-buttons">
          <button class="excel-btn" (click)="exportarExcelSession()" title="Exportar solo sesión actual">
            <i class="fas fa-file-excel"></i>
            <span>Sesión</span>
          </button>

          <button class="excel-btn" (click)="exportarExcel()" title="Exportar todas las sesiones">
            <i class="fas fa-file-excel"></i>
            <span>Completo</span>
          </button>

          <button (click)="exportarDatos()" 
                  class="export-btn"
                  title="Exportar datos">
            <i class="fas fa-download"></i> 
            <span class="btn-text">Exportar</span>
          </button>
          
          <label for="import-file" class="import-btn" title="Importar datos">
            <i class="fas fa-upload"></i> 
            <span class="btn-text">Importar</span>
            <input type="file" 
                   id="import-file" 
                   accept=".json" 
                   (change)="onFileSelected($event)" 
                   style="display: none;">
          </label>
        </div>
        
        <!-- Mobile version - dropdown menu -->
        <div class="mobile-dropdown">
          <button class="dropdown-toggle" 
                  (click)="toggleDropdown()"
                  [class.active]="showDropdown">
            <i class="fas fa-exchange-alt"></i>
            <span class="btn-text">Datos</span>
            <i class="fas fa-chevron-down dropdown-icon" 
               [class.rotated]="showDropdown"></i>
          </button>
          
          <div class="dropdown-menu" [class.show]="showDropdown">
            <button class="dropdown-item" (click)="exportarExcelSession(); closeDropdown()">
              <i class="fas fa-download"></i> Excel Sesión
            </button>
            <button class="dropdown-item" (click)="exportarExcel(); closeDropdown()">
              <i class="fas fa-download"></i> Excel Completo
            </button>
            <button class="dropdown-item" (click)="exportarDatos(); closeDropdown()">
              <i class="fas fa-download"></i> Exportar
            </button>
            <label class="dropdown-item" for="import-file-mobile">
              <i class="fas fa-upload"></i> Importar
              <input type="file" 
                     id="import-file-mobile" 
                     accept=".json" 
                     (change)="onFileSelected($event); closeDropdown()" 
                     style="display: none;">
            </label>
          </div>
        </div>
      </div>
    </div>
  </header>

  <!-- Content with conditional padding -->
  <div class="content-wrapper" [class.with-fixed-header]="(isExamenActivo$ | async)">
    
    <!-- Normal header when exam is NOT active -->
    <header class="normal-header" *ngIf="!(isExamenActivo$ | async)">
      <div class="title-group">
        <h1>Control de Examen</h1>
        <div class="exam-status inactive">
          <i class="fas fa-circle"></i>
          <span>Examen Inactivo</span>
        </div>
      </div>
      
      <div class="header-actions">
        <!-- Start exam button -->
        <button (click)="iniciarExamen()" class="start-exam-btn">
          <i class="fas fa-play"></i> 
          <span class="btn-text">Comenzar Examen</span>
        </button>
      </div>
    </header>

    <!-- Reception registration form - only show when exam is active -->
    <div *ngIf="(isExamenActivo$ | async)" class="reception-section">
      <app-registro-recepcion 
        (estudianteAgregado)="onEstudianteAgregado($event)">
      </app-registro-recepcion>
    </div>

    <!-- Control table - show when exam is active and there are students -->
    <div *ngIf="(isExamenActivo$ | async)" class="control-section">
      <app-tabla-control 
        [estudiantes]="estudiantesExamen$ | async"
        (estudianteEliminado)="onEstudianteEliminado($event)"
        (estudianteEditado)="onEstudianteEditado($event)">
      </app-tabla-control>
    </div>

    <!-- Instructions when exam is not active -->
    <div *ngIf="!(isExamenActivo$ | async)" class="instructions">
      <div class="instructions-content">
        <i class="fas fa-info-circle"></i>
        <h3>Control de Examen</h3>
        <p>Este módulo permite llevar el control de estudiantes durante un examen.</p>
        <ul>
          <li>Registrar estudiantes desde recepción</li>
          <li>Verificar que los estudiantes tomen el examen</li>
          <li>Controlar la integridad de datos</li>
          <li>Detectar progresiones incompletas</li>
        </ul>
        <p><strong>Haga clic en "Comenzar Examen" para iniciar.</strong></p>
        
        <!-- Notice about navigation during active exam -->
        <div class="exam-notice">
          <h4><i class="fas fa-exclamation-triangle"></i> Importante:</h4>
          <p>Durante el examen activo, la navegación principal estará oculta para mantener el foco en el control. 
             Si necesita acceder a otros módulos, abra una nueva pestaña del navegador.</p>
        </div>
      </div>
    </div>
  </div>
  <!-- Precios Modal -->
  <div class="modal-overlay" *ngIf="showPreciosModal" (click)="cancelarPrecios()">
    <div class="modal-content precios-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h4>
          <i class="fas fa-cash-register"></i> 
          Configuración de precios para el examen
        </h4>
        <button class="modal-close" (click)="cancelarPrecios()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <p>Configure los precios que se utilizarán durante el examen. Puede modificarlos más tarde si es necesario.</p>
        
        <div class="precios-form">
          <div class="precio-group">
            <label for="precioExamen">Precio Examen:</label>
            <div class="precio-input">
              <span class="precio-symbol">$</span>
              <input type="number" 
                    id="precioExamen" 
                    [(ngModel)]="preciosForm.examen" 
                    min="0" 
                    step="1000">
            </div>
          </div>
          
          <div class="precio-group">
            <label for="precioLibreta">Precio Libreta:</label>
            <div class="precio-input">
              <span class="precio-symbol">$</span>
              <input type="number" 
                    id="precioLibreta" 
                    [(ngModel)]="preciosForm.libreta" 
                    min="0" 
                    step="1000">
            </div>
          </div>
          
          <div class="maderas-section">
            <div class="maderas-header" (click)="togglePreciosMaderasSection()">
              <h5>Precios de Maderas</h5>
              <i class="fas" [ngClass]="preciosMaderasSectionExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </div>
            
            <div class="maderas-content" [class.collapsed]="!preciosMaderasSectionExpanded">
              <div class="maderas-list">
                <div class="precio-group" *ngFor="let madera of preciosForm.maderas; let i = index">
                  <label>{{ madera.nombre }}:</label>
                  <div class="precio-input">
                    <span class="precio-symbol">$</span>
                    <input type="number" 
                          [(ngModel)]="preciosForm.maderas[i].precio" 
                          min="0" 
                          step="1000">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="cancel-btn" (click)="cancelarPrecios()">
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button class="save-button" (click)="guardarPrecios()">
          <i class="fas fa-save"></i> Guardar
        </button>
      </div>
    </div>
  </div>

</div>